import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { IRichBlockStatList } from '@pure1/data';
import { RichBlockStatusComponent } from '../rich-block-status/rich-block-status.component';

/**
 * A few headline figures as labelled tiles, in declared order — the model ranks them and reading
 * order is part of the answer. `value` arrives raw and is formatted by `DecimalPipe` in the
 * template. Severity shows up as the left stripe, the pill, and the pill's text label (FR-026).
 */
@Component({
    selector: 'copilot-rich-block-stat-list',
    templateUrl: './stat-list-block.component.html',
    styleUrl: './stat-list-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [DecimalPipe, RichBlockStatusComponent],
})
export class StatListBlockComponent {
    readonly block = input.required<IRichBlockStatList>();
}
